export default {
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Wachtwoord",
    forgotPassword: "Wachtwoord vergeten?",
    create_new_account: "Nieuw account aanmaken?",



    "General.msg.error.not_all_required_fields_are_set": "Je hebt niet alle vereiste velden ingevuld."
};